import type { JSX } from 'solid-js';
import { Show } from 'solid-js';
import { tPlural } from '../i18n';
import { StatusPill } from './StatusPill';

// Warnings badge for repo cards + repo detail — sibling of `PolicyStatusBadge`.
// Surfaces the repo's latest `.coderabbit.yaml` translate warnings (deferred /
// unknown / invalid keys, advisory only) as a terse count. A warning NEVER
// blocks or fails a review; this is display-only, so a zero count renders
// nothing (no empty badge clutter).

export type PolicyWarningsBadgeProps = {
  readonly count: number;
};

export function PolicyWarningsBadge(props: PolicyWarningsBadgeProps): JSX.Element {
  return (
    <Show when={props.count > 0}>
      <span data-count={props.count}>
        <StatusPill tone="warning">
          {tPlural('policy_warnings_badge.count', props.count, { count: props.count })}
        </StatusPill>
      </span>
    </Show>
  );
}
